import axios from 'axios';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOCAL_API_URL = 'http://localhost:8000';
const ALPHA_API_URL = 'https://photostat-api.alpha.smilebooth.com';
const PRODUCTION_API_URL = 'https://photostat-api.smilebooth.com';

/* REACT_APP_API_URL overrides the target (e.g. http://localhost:8000 for a
   local cloud + DB); unset, dev keeps hitting production as before. */
export const API_URL =
    process.env.REACT_APP_API_URL ||
    (process.env.NODE_ENV === 'development'
        ? PRODUCTION_API_URL
        : window.location.hostname.indexOf('.alpha.') === -1
        ? PRODUCTION_API_URL
        : ALPHA_API_URL);

export default axios.create({
    baseURL: API_URL,
    withCredentials: true,
});

export const authenticatedApi = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});
